export const States = [
  {id: '', name: '', region: 'US'},
  {id: 'AA', name: 'Armed Forces the Americas', region: 'US'},
  {id: 'AE', name: 'Armed Forces Europe', region: 'US'},
  {id: 'AP', name: 'Armed Forces Pacific', region: 'US'},
  // { "id":"", "name":"", region: 'US'},
  {id: 'AL', name: 'Alabama', region: 'US'},
  {id: 'AK', name: 'Alaska', region: 'US'},
  {id: 'AZ', name: 'Arizona', region: 'US'},
  {id: 'AR', name: 'Arkansas', region: 'US'},
  {id: 'CA', name: 'California', region: 'US'},
  {id: 'CO', name: 'Colorado', region: 'US'},
  {id: 'CT', name: 'Connecticut', region: 'US'},
  {id: 'DE', name: 'Delaware', region: 'US'},
  {id: 'DC', name: 'District of Columbia', region: 'US'},
  {id: 'FL', name: 'Florida', region: 'US'},
  {id: 'GA', name: 'Georgia', region: 'US'},
  {id: 'HI', name: 'Hawaii', region: 'US'},
  {id: 'ID', name: 'Idaho', region: 'US'},
  {id: 'IL', name: 'Illinois', region: 'US'},
  {id: 'IN', name: 'Indiana', region: 'US'},
  {id: 'IA', name: 'Iowa', region: 'US'},
  {id: 'KS', name: 'Kansas', region: 'US'},
  {id: 'KY', name: 'Kentucky', region: 'US'},
  {id: 'LA', name: 'Louisiana', region: 'US'},
  {id: 'ME', name: 'Maine', region: 'US'},
  {id: 'MD', name: 'Maryland', region: 'US'},
  {id: 'MA', name: 'Massachusetts', region: 'US'},
  {id: 'MI', name: 'Michigan', region: 'US'},
  {id: 'MN', name: 'Minnesota', region: 'US'},
  {id: 'MS', name: 'Mississippi', region: 'US'},
  {id: 'MO', name: 'Missouri', region: 'US'},
  {id: 'MT', name: 'Montana', region: 'US'},
  {id: 'NE', name: 'Nebraska', region: 'US'},
  {id: 'NV', name: 'Nevada', region: 'US'},
  {id: 'NH', name: 'New Hampshire', region: 'US'},
  {id: 'NJ', name: 'New Jersey', region: 'US'},
  {id: 'NM', name: 'New Mexico', region: 'US'},
  {id: 'NY', name: 'New York', region: 'US'},
  {id: 'NC', name: 'North Carolina', region: 'US'},
  {id: 'ND', name: 'North Dakota', region: 'US'},
  {id: 'OH', name: 'Ohio', region: 'US'},
  {id: 'OK', name: 'Oklahoma', region: 'US'},
  {id: 'OR', name: 'Oregon', region: 'US'},
  {id: 'PA', name: 'Pennsylvania', region: 'US'},
  {id: 'RI', name: 'Rhode Island', region: 'US'},
  {id: 'SC', name: 'South Carolina', region: 'US'},
  {id: 'SD', name: 'South Dakota', region: 'US'},
  {id: 'TN', name: 'Tennessee', region: 'US'},
  {id: 'TX', name: 'Texas', region: 'US'},
  {id: 'UT', name: 'Utah', region: 'US'},
  {id: 'VT', name: 'Vermont', region: 'US'},
  {id: 'VA', name: 'Virginia', region: 'US'},
  {id: 'WA', name: 'Washington', region: 'US'},
  {id: 'WV', name: 'West Virginia', region: 'US'},
  {id: 'WI', name: 'Wisconsin', region: 'US'},
  {id: 'WY', name: 'Wyoming', region: 'US'},
  // { "id":"", "name":"", region: 'US'},
  {id: 'AS', name: 'American Samoa', region: 'US'},
  {id: 'GU', name: 'Guam', region: 'US'},
  {id: 'MH', name: 'Marshall Islands', region: 'US'},
  {id: 'MP', name: 'Northern Mariana Islands', region: 'US'},
  {id: 'PR', name: 'Puerto Rico', region: 'US'},
  {id: 'VI', name: 'Virgin Islands, U.S.', region: 'US'},
  // { "id":"", "name":"", region: 'US'},
  {id: 'AB', name: 'Albert', region: 'CA'},
  {id: 'BC', name: 'British Columbia', region: 'CA'},
  {id: 'MB', name: 'Manitoba', region: 'CA'},
  {id: 'NB', name: 'New Brunswick', region: 'CA'},
  {id: 'NF', name: 'Newfoundland', region: 'CA'},
  {id: 'NT', name: 'Northwest Territories', region: 'CA'},
  {id: 'NS', name: 'Nova Scotia', region: 'CA'},
  {id: 'NU', name: 'Nunavut', region: 'CA'},
  {id: 'ON', name: 'Ontario', region: 'CA'},
  {id: 'PE', name: 'Prince Edward Island', region: 'CA'},
  {id: 'QC', name: 'Quebec', region: 'CA'},
  {id: 'SK', name: 'Saskatchewan', region: 'CA'},
  {id: 'YT', name: 'Yukon Territory'}
]
